

/**
 * @fileOverview App module definition
 * @author JMACK
 * @modified 05/19/2014
 */

 (function (context) {
    'use strict';

    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('App',['require','jquery','lib/Util','utility/loadDPL','polyfills/matchmedia','picturefill','polyfills/requestAnimationFrame','polyfills/function.bind','lib-thirdparty/modernizr-2.6.2','lib-thirdparty/jquery.touchhooks','validate','polyfills/lazyLoadImages','models/EventDispatcher','GlobalResizeListener','controllers/ContentToggleController','controllers/ModalLaunchController','controllers/NavigationRelocationController','controllers/NavigationSubMenuController','controllers/ContentRelocationController','views/Tabs','controllers/ResponsiveAccordion','controllers/AjaxLoader','controllers/ComparisonValidator','views/CarouselView','controllers/CarouselController','controllers/CheckboxToggleController','views/ThumbnailSliderView','views/ContentSliderView','controllers/ContentFilterController','controllers/ContentSliderController','views/ListToSelectList','views/ListToPushDown','GlobalEventDispatcher','views/HotSpotView','views/ExpandContentView','views/ShowSlideView','views/SelectorView','controllers/mmmThemeControls','lib/domCallback','views/FancyDropDown','views/Select2DropDown','views/UpdateLayoutChanges','controllers/ExternalLinkCheck','controllers/LightBox','controllers/ButtonController','views/DynamicDropdownValues','controllers/AnchorController','apps/gsn/controller','controllers/SearchController','controllers/GSNController','controllers/ProfileController','controllers/SecondaryNavController','views/ssnHighlight','controllers/ExpandableController','views/FooterBtnView','views/bcomCartView','kungfu/ComplianceBanner/ComplianceBanner'],function (require) {

        // List all scripts that need to be loaded before everything else. Suitable for browser polyfills, etc.
        var $ = require('jquery');
        var Util = require('lib/Util');
		var dplLoader = require('utility/loadDPL');
        
        //check for any priority modules and execute
        if (priorityModules.length !== 0){
            require(priorityModules);
        };

        require('polyfills/matchmedia');
        require(['picturefill1'], function () { window.picturefill(); });
        require('picturefill');
        require('polyfills/requestAnimationFrame');
        require('polyfills/function.bind');
        require('lib-thirdparty/modernizr-2.6.2');
        require('lib-thirdparty/jquery.touchhooks');
        require('validate');
        require('polyfills/lazyLoadImages');

        var EventDispatcher = require('models/EventDispatcher');
        var GlobalResizeListener = require('GlobalResizeListener');
        var ContentToggleController = require('controllers/ContentToggleController');
        var ModalLaunchController = require('controllers/ModalLaunchController');
        var NavigationRelocationController = require('controllers/NavigationRelocationController');
        var NavigationSubMenuController = require('controllers/NavigationSubMenuController');
        var ContentRelocationController = require('controllers/ContentRelocationController');
        var Tabs = require('views/Tabs');
        var ResponsiveAccordion = require('controllers/ResponsiveAccordion');
        var ContentLoader = require('controllers/AjaxLoader');
        var ComparisonValidator = require('controllers/ComparisonValidator');
        var CarouselView = require('views/CarouselView');
        var CarouselController = require('controllers/CarouselController');
        var CheckboxToggleController = require('controllers/CheckboxToggleController');
        var ThumbnailSliderView = require('views/ThumbnailSliderView');
        var ContentSliderView = require('views/ContentSliderView');
        var ContentFilterController = require('controllers/ContentFilterController');
        var ContentSliderController = require('controllers/ContentSliderController');
        var ListToSelectList = require('views/ListToSelectList');
        var ListToPushDown = require('views/ListToPushDown');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');
        var HotSpotView = require('views/HotSpotView');
        var ExpandContentView = require('views/ExpandContentView');
        var ShowSlideView = require('views/ShowSlideView');
        var SelectorView = require('views/SelectorView');
        var MMMThemeControls = require('controllers/mmmThemeControls');
        var DomCallback = require('lib/domCallback');
        //var MMMForeSee = require('kungfu/foresee/loader');
        // var MMMWebtrendsLoader = require('webtrends'); This is now loaded conditionally
        //var MMMSalesForce = require('salesforce');
		var FancyDropDown = require('views/FancyDropDown');
        var Select2DropDown = require('views/Select2DropDown');
        var MMMLayoutChanges = require('views/UpdateLayoutChanges');
		var MMMLinkCheck = require('controllers/ExternalLinkCheck');
		var MMMLightBox = require('controllers/LightBox');
        var ButtonController = require('controllers/ButtonController');
		var MMMDynamicDropdownValues = require('views/DynamicDropdownValues');
        var MMMAnchorController = require('controllers/AnchorController');

        // New Redesign GSN
        var newGSN = require('apps/gsn/controller');
        
        var Unicorn = {};
        //pull in all the modules - but only fire them if needed (unicorn)
        Unicorn.searchController = require('controllers/SearchController');
        Unicorn.gsnController = require('controllers/GSNController');
        Unicorn.profileController = require('controllers/ProfileController');
        Unicorn.secondaryNavController = require('controllers/SecondaryNavController');
        Unicorn.ssnHighlight = require('views/ssnHighlight');
        Unicorn.expandableController = require('controllers/ExpandableController');
        // Unicorn.tealiumCookie = require('kungfu/Tealium/TealiumCookie'); This is now loaded conditionally
        Unicorn.footerBtnView = require('views/FooterBtnView');
        Unicorn.bComCartView = require('views/bcomCartView');
        Unicorn.complianceBanner = require('kungfu/ComplianceBanner/ComplianceBanner');
        //Unicorn.themeHDView = require('views/ThemeHDView');
        
        // Tealium includes its own Web Trends, so only load Tealium on non-legacy sites and only load WebTrends on legacy sites
        if(SETTINGS.theme !== 'legacy' && urlHash['wt-override'] !== 'true'){
        //if(SETTINGS.theme !== 'legacy'){
            $debug('theme is not Legacy');
            if(SETTINGS.Tealium !== false){
                Unicorn.tealiumCookie = require(['kungfu/Tealium/TealiumCookie']);
            }
        } else{
            $debug('theme is Legacy');
            var MMMWebtrendsLoader = require(['webtrends']);
            var MMMForeSee = require(['kungfu/foresee/loader']);
        }
        $('form').each(function(){
	       if($(this).hasClass('eloquaForm')){
                Unicorn.progProfiling = require (['kungfu/Eloqua/progProfiling']);
            }

        });
        if (SETTINGS.LOCALE === 'fr_CA') {
            $debug('locale is French Canadian... fetching MMMhtmlreplace for MC replacement');
            var MMMhtmlreplace = require(['kungfu/HTMLReplace/mmmHTMLReplace']);
        };
        //var MMMFaceBook = require('kungfu/facebook/fb');

        // Displays system messages if one has been configured, used to communicate outtages or performance issues
        if(SETTINGS.systemMessage !== undefined && SETTINGS.systemMessage !== ''){
            require(['views/systemMsgView']);
        }

        /**
         * Initial application setup. Runs once upon every page load.
         *
         * @name App
         * @class App Initial application setup. Runs once upon every page load.
         * @constructor
         */
        var App = function () {

            /**
             * This defines mapping between a CSS class and an JavaScript
             * component and puts it into an object literal.
             */

            this.classComponentMapping = [
                { cssClass: '.js-moreList',             JsType: ShowSlideView },
                { cssClass: '.js-tabs',                 JsType: Tabs },
                { cssClass: '.js-toggle',               JsType: CheckboxToggleController },
                { cssClass: '.js-hotspots',             JsType: HotSpotView },
                { cssClass: '.js-expandableContent',    JsType: ExpandContentView },
                { cssClass: '.js-selectorFilter',       JsType: SelectorView }
            ];

            this.init();
        };

        /**
         * Initializes the component
         * This delegates the triggering of the 'attachjs' event on any html element
         * This allows new elements to be added even after this event handler is attached
         *
         *  @since 1.0
         */
        App.prototype.init = function () {
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher(); // event dispatcher that will call the event
            //initialize the resize listener
            this.globalResizeListener = GlobalResizeListener.getResizeListener();
            var self = this;
			
			// Client-side DPL loading init
			$('.js-loadOnDemand').each(function(){
				$debug('Firing DPL client side loader, use debug=loadDPL for more information...');
				new dplLoader($(this), $(this).attr('data-oid'));
            });
            
            //New GSN redesign
            if ($('.m-nav').length !== 0){
                $debug('event 2 = newGSNController');
                new newGSN();
            }

            //new unicorn theme additions
            if (SETTINGS.THEME && SETTINGS.THEME !== 'legacy' || SETTINGS.theme && SETTINGS.theme !== 'legacy'){
                $debug('firing unicorn babies');
                $('.js-expandableHdr').each(function(i){
                    $debug('event 1 = expandable controller');
                    new Unicorn.expandableController($(this));
                });

                if ($('#js-gsnList').length !== 0){
                    $debug('event 2 = gsnController');
                    new Unicorn.gsnController();
                }

                if ($('#js-signInIcon').length !== 0){
                    $debug('event 3 = profileController');
                    new Unicorn.profileController($('#js-signInIcon'));
                }

                if ($('.js-secondaryNavLink').length !== 0){
                    $debug('event 4 = secondary nav controller');
                    $('.js-secondaryNavLink').each(function(){
                        $debug('event 4.1');
                        if(typeof $(this).data('uniquename') === 'string' && $(this).data('uniquename').indexOf('#') < 0){
                            new Unicorn.secondaryNavController($(this));
                        }
                    });
                    new Unicorn.ssnHighlight();
                }

                if ($('.MMM--ftCTAs .mix-MMM--btn_linkInMobileOnly').length !== 0){
                    $debug('event 5 = footer mobile button link controller');
                    $('.MMM--ftCTAs .mix-MMM--btn_linkInMobileOnly').each(function(){
                        $debug('event 5.1 = footer button view');
                        new Unicorn.footerBtnView($(this));
                    });
                }

                if ($('.MMM--searchBar').length !== 0){
                    $debug('event 6 = search controller');
                    new Unicorn.searchController();
                }

                if ($('.js-bComCart').length !== 0){
                    $debug('event 7 = bCom Cart View');
                    $('.js-bComCart').each(function(i){
                        new Unicorn.bComCartView($(this));
                    });
                }

                // Load complainceBanner always, the JS is loaded anyway we can check if it needs to actually do anything in complianceRules.js
                $debug('event 8 = Compliance Banner Modal');
                new Unicorn.complianceBanner();
/*
                if ($('#js-siteHd').length !== 0){
                    $debug('event 9 = Theme HD View');
                    new Unicorn.themeHDView();
                }
*/

                // Note that configurations can be set to null to bypass this logic, this is by design so that a widget can be configured without a form
                if ( (typeof window.SETTINGS.sfDeployID !== 'undefined' || typeof window.SETTINGS.salesforceName !== 'undefined') && (typeof window.SETTINGS.contextSupportFormPath !== 'undefined' || typeof window.SETTINGS.contextSupportFormUrl !== 'undefined') ){
                    $debug('event 10 = Salesforce Contextual Help Widget');
                    require(['kungfu/contextSupportWidget/loader']);
                }
            }
            else {
                $debug('no unicorn babies');
            }

            // Application-like DPLs
            if($('.rLrn-50-CourseGrid').length > 0){
                $debug('rLrn-50-CourseGrid found, firing controller...');
                require(['apps/rLrn/controllers/rLrn-50-CourseGrid']);
            }
            
            $('.js-contentTrigger').each(function (i,e) {
                $debug('Content Trigger Block #' + (i + 1), 'contentToggleControl');
                new ContentToggleController(this, self);
            });

            //allow enter key to be used to submit forms - even if hidden on page load. MDPL-166
            $('form input').keypress(function (e) {
                if(e.which === 13) {
                    $debug('submit form');
                    $(this).parents('form').first().submit();
                }
            });

            $('.js-modalTrigger').each(function (i,e) {
                new ModalLaunchController(this, self);
            });

            $('.js-triggerLink').each(function (i,e) {
                $debug('Nav Controller Block #' + (i + 1), 'navSubMenuController');
                new NavigationSubMenuController(this, self);
            });

            $('.js-triggerLink_secondary').each(function (i,e) {
                new NavigationSubMenuController(this, self);
            });

            $('.js-listToPushDown').each(function (i,e) {
                new ListToPushDown(this, self);
            });

            // If the browsers does not support media queries, do not initialize the ContentRelocationController, relies on Modernizr.js
            var navigationRelocationController = new NavigationRelocationController(this);
            this.MMMThemeControls = new MMMThemeControls(this);

            this.toggleController = new ResponsiveAccordion({selector: '.js-contentToggle-trigger', hasDefaultState: true, jumpsToTop: true, application: this});
            this.staticToggleController = new ResponsiveAccordion({selector: '.js-contentToggle-trigger_static', alwaysActive: true, jumpsToTop: false, isTwisty: true, application: this});
            this.resourceToggleController = new ResponsiveAccordion({selector: '.js-contentToggle-trigger_resource', alwaysActive: true, jumpsToTop: true, application: this});
            this.nonJumpToggleController = new ResponsiveAccordion({selector: '.js-contentToggle-trigger_noJump', alwaysActive: true, jumpsToTop: false, application: this});
            this.filterToggleController = new ResponsiveAccordion({selector: '.js-contentToggle-trigger_filter', alwaysActive: true, jumpsToTop: true, application: this});
            this.relatedToggleController = new ResponsiveAccordion({selector: '.js-contentToggle-trigger_related', hasDefaultState: true, jumpsToTop: false, application: this});
            this.allModelFilterToggleController = new ResponsiveAccordion({selector: '.js-contentToggle-trigger_allModelFilter', alwaysActive: true, jumpsToTop: true, application: this}),
            this.largeAccordion = new ResponsiveAccordion({selector: '.js-contentToggle-trigger_largeAccordion', alwaysActive: true, jumpsToTop: true, application: this});
            this.largerAccordion = new ResponsiveAccordion({selector: '.js-contentToggle-trigger_twisty', alwaysActive: true, jumpsToTop: false, isTwisty: true, application: this});

            //multiple instances for accordion
            $('.rC-53-Accordion').each(function(i, e) {
                var ele = $(e),
                    largerAccordion = ele.find('.js-contentToggle-trigger_largeAccordion');
                new ResponsiveAccordion({selector: largerAccordion, alwaysActive: true, jumpsToTop: true, application: this});
            });

            if ($('.js-menuList').length !== 0){
                this.navSelect = new ListToSelectList('.js-menuList', this);
			}
			//fancy drop down menu
			$('.js-fancyDropDown').each(function(i, e) {
                // double checks the element hasn't already been loaded
                if (!$(this).hasClass("fancyDropDownLoaded")){
                    $(this).addClass("fancyDropDownLoaded");
                    new FancyDropDown($(this));
                }
			});

            //select2 drop down menu
            $('.js-selectDropDown').each(function(i, e) {
                new Select2DropDown(e, this);
            });
			
			//External Link check			
			this.MMMLinkCheck = new MMMLinkCheck(this);
			
			//dynamic drop down values
			$('.js-dynamicDDvalues').each(function(i, e) {
				new MMMDynamicDropdownValues(e, this);
			});

            //create AJAX loader sections. Keep first section for historical purposes
            if ($('a.js-contentLoader').length > 1) {
                $('a.js-contentLoader').each(function (i,e) {
                    new ContentLoader(this, self);
                });
            }
            else {
                this.contentLoader = new ContentLoader('a.js-contentLoader');
            }

            this.comparisonValidator = new ComparisonValidator('#comparisonForm');
            this.comparisonValidatorSecondary = new ComparisonValidator('#comparisonFormSecondary');

            $('.rG-03-Carousel, .rG-81-Carousel').each(function(i, e) {
                var ele = $(e),
                    carouselV = ele.find('.js-heroCarousel'),
                    navControl = ele.find('.js-carouselNavigation'),
                    heroStory = ele.find('.MMM--carouselListItem_contentList'),
                    heroStoryDot = ele.find('.MMM--heroCarouselNavigation-item a'),
                    $uniqueID = $randomNumber(100000);

                ele.attr("id", "carousel-" + $uniqueID);
                navControl.attr("id", "js-carouselNavigation" + $uniqueID);
                carouselV.attr("id", "js-carousel" + $uniqueID);

                $(heroStory).each(function(n) {
                    $(this).attr("id", "heroStory" + n + $uniqueID);
                });

                $(heroStoryDot).each(function(n) {
                    $(this).attr("href", "#heroStory" + n + $uniqueID);
                });

            });

            // Initializes the carouselView, stores a reference to pass into other controllers that need to know about the carousel
            if ($('#js-carousel').length > 0) {
                this.carousel = new CarouselView('#js-carousel', this);
                this.carouselController = new CarouselController({carousel: this.carousel, triggerSelector: '.js-variationList-trigger', domTrigger: '#js-variationsModalTrigger'}, this);
            }

            $('.js-thumbnailSlider').each(function(i, e) {
                var ele = $(e);
                var eleId = '#' + ele.attr('id');

                this.thumbnailSlider = new ThumbnailSliderView(eleId, self);
            });

            // supplying ids to the set of stories and stroy dots for the animation MDPL-1167
            $('.rG-50-Tiles').each(function(i, e) {
                var ele = $(e),
                    navControl = ele.find('.js-carouselNavigation'),
                    heroStory = ele.find('.MMM--carouselListItem_hero'),
                    heroStoryDot = ele.find('.MMM--heroCarouselNavigation-item a'),
                    $uniqueID = $randomNumber(100000);
                ele.attr("id", "rG-50carousel-" + $uniqueID);

                $(navControl).each(function(n) {
                    $(this).attr("id", "js-carouselNavigation" + n + $uniqueID);
                });

                $(heroStory).each(function(n) {
                    $(this).attr("id", "heroStory" + n + $uniqueID);
                });

                $(heroStoryDot).each(function(n) {
                    $(this).attr("href", "#heroStory" + n + $uniqueID);
                });

            });

            $('.js-heroCarousel').each(function(i,e) {
                var ele = $(e);
                var eleId = '#' + ele.attr('id');
                var caroselControlContainerId = '#' + ele.find('.js-heroNavigationContainer').find('.js-carouselNavigation').attr('id');
                //This is for rG-50-4upTiles because the html structure is different than the other carousels
                if(ele.find('.js-heroNavigationContainer').find('.js-carouselNavigation').attr('id') == undefined){
                    caroselControlContainerId = "#" + ele.next().find('.js-carouselNavigation').attr('id');
                }

                //picturefill and onLoad fix
                ele.css('visibility', 'visible');
				ele.find('.js-dataSrc img').css('display', 'block');
                ele.find('picture img').css('display', 'block');
                ele.find('.js-heroNavigationContainer').css('visibility', 'visible');
                
                this.heroCarousel = new CarouselView(eleId, self);
                this.heroCarouselController = new CarouselController({carousel: this.heroCarousel, triggerSelector: caroselControlContainerId + ' > li > a'}, this);
            });

            if ($('#js-heroCarousel-short').length > 0) {
                this.heroCarousel = new CarouselView('#js-heroCarousel-short', this);
                this.heroCarouselController = new CarouselController({carousel: this.heroCarousel, triggerSelector: '#js-carouselNavigation-short > li > a'}, this);
            }

            $('.js-heroCarousel-alt').each(function(i, e) {
                //cache the jQuery selector
                var ele = $(e);
                // get the ID of DOM element (e).  Returned as a string
                var eleId = '#' + ele.attr('id');

                //picturefill and onLoad fix
                ele.css('visibility', 'visible');
                ele.find('.js-dataSrc img').css('display', 'block');
                ele.next('.MMM--heroNavigationContainer_carousel').css('visibility', 'visible');

                // Search the child elements sibling element of DOM element (e) for .js-heroCarouselThumbnails-links abd get the ID
                var thumbnailControllerContainerId = '#' + ele.next('.MMM--heroNavigationContainer_carousel').find('.js-heroCarouselThumbnails-links').attr('id');

                // Search the child elements sibling element of DOM element (e) for .js-carouselNavigationils-links and get the ID.
                var mobileThumbnailContollerContainerId = '#' +  ele.nextAll('.MMM--heroNavigationContainer').find('.js-carouselNavigation').attr('id');
              
                this.heroCarouselAlt = new CarouselView(eleId, self);
                this.heroCarouselAltController = new CarouselController({carousel: this.heroCarouselAlt, triggerSelector: thumbnailControllerContainerId + ' > li > a'}, this);
                this.heroCarouselAltControllerMobile = new CarouselController({carousel: this.heroCarouselAlt, triggerSelector: mobileThumbnailContollerContainerId + ' > li > a'}, this);
            });

            $('.js-contentList').each(function(i, e) {
                var ele = $(e);
                var eleId = '#' + ele.attr('id');

                var contentFilter = ele.parent().prev('div').find('.js-contentFilter');
                var cotentFilderId = '#' + contentFilter.attr('id');

                var sliderController = ele.parent().next('.MMM--contentWrapper').find('.js-sliderController');
                var slideControllerId = '#' + sliderController.attr('id');

                this.contentSliderView = new ContentSliderView(eleId, self);
                this.contentFilterController = new ContentFilterController(cotentFilderId, this.contentSliderView, this);
                this.contentSliderController = new ContentSliderController(slideControllerId, this.contentSliderView, this);
            });

            if($('.video-js').length > 0) {
                $debug('Found a video player not belonging to a DPL, firing mmmVideoModule...');

                require(['kungfu/video/mmmVideoModule']);
            }

            $(document.body)
                .on('attachjs', this.onAttachJS.bind(this))
                .on('attachjs', '*', this.onAttachJS.bind(this));
            window.mmmApp = {
                'Lightbox' : MMMLightBox,
                'ResponsiveAccordion' : ResponsiveAccordion,
                'Tabs' : Tabs,
                'ContentLoader' : ContentLoader,
                'CarouselView' : CarouselView,
                'CarouselController' : CarouselController,
                'CheckboxToggleController' : CheckboxToggleController,
                'ThumbnailSliderView' : ThumbnailSliderView,
                'ContentSliderView' : ContentSliderView,
                'ContentFilterController' : ContentFilterController,
                'ContentSliderController' : ContentSliderController,
                'ListToSelectList' : ListToSelectList,
                'HotSpotView' : HotSpotView,
                'ExpandContentView' : ExpandContentView,
                'ShowSlideView' : ShowSlideView,
                'SelectorView' : SelectorView,
				'FancyDropDown' : FancyDropDown,
                'Select2DropDown' : Select2DropDown,
                'AnchorController' : MMMAnchorController,
                'ModalLaunchController' : ModalLaunchController
            };
			
			/**
			 *Excecuting the Truncate function
			 *Truncate the Multine Text with '...'
			 */
			Util.truncateTxt('.js-ellipses');

            /**
             *Excecuting the socialFooter function
             *Add social footer to footer ribbon container on Desktop
             */
            Util.socialFooter('.js-socialFooter');

            /**
             *Excecuting the removePtagwithSpace function
             *
             */
            Util.removePtagwithSpace('p[dir=ltr], p');

            /**
             *Excecuting the ScrollToJumpMenu function
             *Scrolls to the MMM--TopJumpMenu ID container
             */
            $('.MMM--jumpTop').each(function(){
                $(this).on('click', function() {
                    if ($('#MMM--TopJumpMenu').length) {
                        Util.mmmScrollToJumpMenu('#MMM--TopJumpMenu');
                    } else if ($('#top').length) {
                        Util.mmmScrollToJumpMenu('#top');
                    } else {
                        Util.mmmScrollToJumpMenu('body');
                    }
                });
            });
			
			/**
			 * Eloqua form-related functions
			 * Include if an Eloqua form is present on the page
			 */
			
			$('form').each(function(){
				if($(this).hasClass('eloquaForm')) {
					var $form = $(this);
					
					require(['kungfu/Eloqua/mmmEloqua'], function(mmmEloqua){
						new mmmEloqua($form);
					});
				}
			});

            /**
             *Executing the hash scroll function
             *Scrolls to the hash anchor after page content loads
             */
            require(['domReady!'], function (doc){
                try {
                    if($(window.location.hash).length){
                        $('html, body').animate({
                            'scrollTop': $(window.location.hash).offset().top
                        });
                    }
                }
                catch (err) {
                    $debug('Page element: ' + window.location.hash + 'does not exist.');
                }
            });

            // Remove all "Russian Federation" and Belarus options from any form due to global sanctions and 3M's business withdrawal from Russia
            window.$removeCountryForm([
                /Russian[ ]*Federation/gm,
                /Belarus/gm
            ]);
        };

        /**
         * Convenience method for handling triggering of attach component event.
         *
         * Example usage:
         *    $(document.body).trigger('attachjs'); // attaches to all
         *    $('.my-container').trigger('attachjs'); // attaches within a specified container only
         *
         *  @since 1.0
         */
        App.prototype.onAttachJS = function (e) {
            $debug('***AttachJS Fired***');
            var $container = $(e.currentTarget);
            this.initComponents($container, this.classComponentMapping);
        };

        /**
         * Attaches JavaScript components to DOM elements.
         * Will search for matching class names among all of the containers's child elements, including the element itself.
         * This should be called again whenever new elements are added to the page dynamically (via AJAX, etc).
         *
         * @param {JQuery} $container Container to start searching for suitable DOM elements to attach components to.
         * @param {object} classComponentMapping Structure containing mapping of CssClass selector and JavaScript class name as key/value pairs.
         *
         *  @since 1.0
         */
        App.prototype.initComponents = function ($container, classComponentMapping) {
            $debug('   Initializing Components...');
            var self = this;

            for (var i = 0; i < classComponentMapping.length; i++) {
                var cssClass = classComponentMapping[i].cssClass;
                var JsType = classComponentMapping[i].JsType;
                $container
                    .find(cssClass)
                    .addBack(cssClass)
                    .each(function(index, element) {
                        $debug('      Initializing Component: ' + cssClass);
                        self.initComponent($(element), JsType);
                    });
            }

            return false;
        };

        /**
         * Attaches a JavaScript component to a DOM elements.
         * Only attaches if the component is not already initialized for that DOM element
         *
         * @param {jQuery} $element The element to attach the component to
         * @param {object} JsType JavaScript class representing the component to attach
         *
         * @since 1.0
         */
        App.prototype.initComponent = function($element, JsType) {
            $debug('initComponent...');
            //if (!Util.isInitialized($element, JsType.id)) {
            new JsType($element);
            //}
        };

        return App;
    });

}(MMMRequire));

